import StyledContainer from "./Container.styled";

export default StyledContainer;
